export default __webpack_public_path__ + "static/comming-for-1-5b0bf579a3fb15554272b316429b55d6.png";